/**
 * Custom Product Layout
 *
 * Moves the accordion block based on viewport:
 * - Desktop (>=750px): inside media-gallery (below images, part of sticky)
 * - Mobile  (<750px):  end of the grid (below all product details)
 */

const initAccordionPlacement = () => {
  const grid = document.querySelector('.product-information__grid');
  if (!grid) return;

  const gallery = grid.querySelector('media-gallery');
  const accordion =
    grid.querySelector('.product-details .accordion') ||
    grid.querySelector('media-gallery > .accordion') ||
    grid.querySelector(':scope > .accordion');
  if (!gallery || !accordion) return;

  const mq = window.matchMedia('(min-width: 951px)');

  const place = () => {
    if (mq.matches) {
      gallery.appendChild(accordion);
    } else {
      grid.appendChild(accordion);
    }
  };

  place();
  mq.addEventListener('change', place);
};

initAccordionPlacement();
